<template>
  <div>
    <v-toolbar
      flat
      class="elevation-1"
    >
      <v-toolbar-title>Usuarios</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        label="Buscar"
        single-line
        hide-details
        v-model="filtros.search"
        v-on:keyup.enter="filtrar"
      >
      </v-text-field>
      <v-btn
        color="secondary"
        fab
        small
        @click="filtrar()"
      >
        <v-icon class="primary--text">search</v-icon>
      </v-btn>
      <v-btn
        v-if="puedo('alta')"
        class="white--text"
        round
        color="primary"
        @click="crear"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >add</v-icon>
        Nuevo

      </v-btn>
    </v-toolbar>
    <v-data-table
      must-sort
      :headers="headers"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <template v-slot:items="props">
        <td class="text-xs-center pa1">{{ props.item.id }}</td>
        <td class="text-xs-left pa1">{{ props.item.usuario }}</td>
        <td class="text-xs-left pa1">{{ props.item.persona.nombre + ' ' + props.item.persona.apellido }}</td>
        <td class="text-xs-left pa1">
          <v-chip
            small
            color="blue-gray"
            v-for="(item,key) in institucionesFormateadas(props.item.instituciones)"
            :key="key"
          >{{ item }}</v-chip>
        </td>
        <td class="text-xs-left pa1">
          <v-chip
            small
            color="blue-gray"
            v-for="(item,key) in rolesFormateados(props.item.roles)"
            :key="key"
          >{{ item }}</v-chip>
        </td>
        <td class="justify-center layout ">
          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-0"
            v-if="puedo('lectura') || puedo('modif')"
            @click="ver(props.item)"
          >
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-1"
            v-if="puedo('modif')"
            @click="verPermisos(props.item)"
          >
            <v-icon small>lock</v-icon>
          </v-btn>
          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-1"
            v-if="puedo('baja')"
            @click="eliminar(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>

import abmListadoMixin from '@/mixins/abmListado'
import _ from 'lodash'
import { nombreCentro } from '@/helpers/filtros'

export default {
  name: 'PermisosAbmListado',
  mixins: [abmListadoMixin],
  filters: {
    nombreCentro
  },
  data: () => ({
    headers: [
      {
        text: 'ID',
        align: 'center',
        value: 'id'
      },
      { text: 'Usuario', value: 'usuario' },
      { text: 'Nombre y apellido', value: 'persona.nombre', sortable: false },
      { text: 'Centros', value: 'name', sortable: false },
      { text: 'Rol', value: 'name', sortable: false },
      { text: '', value: 'name', sortable: false, align: 'center' }
    ]
  }),
  methods: {
    verPermisos (item) {
      this.$emit('verPermisos', item)
    },
    rolesFormateados (roles) {
      return _.map(roles, item => {
        return item.name
      })
    },
    institucionesFormateadas (instituciones) {
      return _.map(instituciones, item => {
        return item.institucion !== null ? this.$options.filters.nombreCentro(item.institucion) : ''
      })
    }
  }
}
</script>
